
import { computed, nextTick, onMounted, ref, watch, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Swiper, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
import ArchiveBanner from '@/components/block/ArchiveBanner.vue'
import EventCard from '@/components/block/EventCard.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'JoinMyFes',

  components: {
    ArchiveBanner,
    EventCard,
    HeadingLv2,
    Button
  },

  props: {
    heading: {
      type: String,
      default: 'イベントに参加する'
    },
    navigation: {
      type: Array,
      default: () => []
    }
  },

  setup() {
    const store = useStore()
    const events = computed(() => store.getters['home/getEvents'])
    const visibleClass = (arr: any) => ({
      hiddenPc: !arr.includes('pc'),
      hiddenSp: !arr.includes('sp')
    })

    const mySwiper = ref<any>(null)
    watch(
      () => events.value,
      () => {
        nextTick(() => mySwiper.value.update())
      }
    )

    onMounted(() => {
      Swiper.use([Navigation])
      mySwiper.value = new Swiper('.joinMyFesSwiper', {
        breakpoints: {
          900: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
          }
        },
        slidesPerView: 1.4,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        navigation: {
          nextEl: '.joinMyFesSwiperNext',
          prevEl: '.joinMyFesSwiperPrev'
        }
      })
    })

    return {
      visibleClass,
      events
    }
  }
})
